(() => {
  'use strict';
  const rootPath = window.Shopify?.routes?.root || '/';
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const syncBuyOneCopy = (root) => {
    const active = q('[data-offer-tier].is-active', root);
    const quantity = Number(active?.dataset.offerTier || 1);
    const discount = Number(active?.dataset.offerDiscount || 0);
    const message = q('[data-limited-offer-tier-message]', root);
    const label = q('[data-limited-offer-submit] span', root);
    if (quantity === 1) {
      if (message) message.textContent = 'Buy 1 at the regular price.';
      if (label) label.textContent = 'Buy 1 Now';
    } else {
      if (message) message.textContent = `Buy ${quantity} and save ${discount}% automatically.`;
      if (label) label.textContent = `Buy ${quantity} Now — Save ${discount}%`;
    }
  };

  const directCheckout = async (root, event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const active = q('[data-offer-tier].is-active', root);
    const quantity = Number(active?.dataset.offerTier || 1);
    const discount = Number(active?.dataset.offerDiscount || 0);
    const rows = qa('[data-offer-item]', root);
    const variantIds = rows.map((row) => row.dataset.variantId).filter(Boolean);
    const status = q('[data-limited-offer-status]', root);
    const submit = q('[data-limited-offer-submit]', root);
    const label = q('span', submit);
    const previousLabel = label?.textContent || '';

    if (variantIds.length !== quantity) {
      if (status) { status.textContent = 'Choose an available variant for every item.'; status.classList.add('is-error'); }
      return;
    }

    const quantities = new Map();
    variantIds.forEach((id) => quantities.set(id, (quantities.get(id) || 0) + 1));
    const items = Array.from(quantities.entries()).map(([id, itemQuantity]) => ({
      id,
      quantity: itemQuantity,
      properties: { '_Limited time offer': `Buy ${quantity} — ${discount}% off` }
    }));

    if (submit) submit.disabled = true;
    if (label) label.textContent = 'Opening secure checkout…';
    if (status) { status.textContent = 'Adding your deal and opening checkout…'; status.classList.remove('is-error'); }

    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this deal.');
      document.dispatchEvent(new CustomEvent('novacart:cart-updated', { detail: result }));
      window.location.assign(`${rootPath}checkout`);
    } catch (error) {
      if (status) { status.textContent = error.message || 'Unable to add this deal. Please try again.'; status.classList.add('is-error'); }
      if (submit) submit.disabled = false;
      if (label) label.textContent = previousLabel;
    }
  };

  const initRoot = (root) => {
    if (!root || root.dataset.dealCheckoutOverride === 'true') return;
    root.dataset.dealCheckoutOverride = 'true';
    const buyOne = q('[data-offer-tier="1"]', root);
    window.setTimeout(() => {
      buyOne?.click();
      syncBuyOneCopy(root);
    }, 0);
    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-offer-tier]')) window.setTimeout(() => syncBuyOneCopy(root), 0);
    });
    q('[data-limited-offer-submit]', root)?.addEventListener('click', (event) => directCheckout(root, event), true);
  };

  const init = (context = document) => {
    if (context.matches?.('[data-limited-offer]')) initRoot(context);
    qa('[data-limited-offer]', context).forEach(initRoot);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => window.setTimeout(() => init(event.target), 0));
})();
